import React, { useEffect, createContext, useContext, useState } from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles/reset.scss";
import "./styles/animation.scss";
import $ from "jquery";
import NoMatch from "./components/NoMatch";
import { pcRoutes } from "./routes";
import { queryAllChannel } from "./service";
import "./styles/page.scss";

const NavContext = createContext();

function App() {
  const [navData, setNavData] = useState([]);
  const [navData2, setNavData2] = useState([]);
  const [isPhone, setisPhone] = useState(false); //是否是手机
  const [isBigScreen, setisBigScreen] = useState(false); //是否是大屏

  useEffect(() => {
    queryAllChannel().then((res) => {
      localStorage.setItem(
        "channelId",
        res?.records?.filter((item) => {
          return item.channelNo === "Resource";
        })?.[0]?.channelId
      );
      setNavData(
        res?.records?.filter((item) => {
          return item.channelNo === "Resource";
        })?.[0]?.subChannel
      );
    });
    queryAllChannel("GQPopularS").then((res) => {
      localStorage.setItem(
        "channelId",
        res?.records?.filter((item) => {
          return item.channelNo === "Resource";
        })?.[0]?.channelId
      );
      const navdata2 = res?.records;
      setNavData2(navdata2);
    });
  }, []);
  let i = navigator.userAgent.toLowerCase();

  useEffect(() => {
    if (/iphone|ipad|android|BlackBerry/.test(i)) {
      setisPhone(true);
    }
    if (window.innerWidth > 3000) {
      setisBigScreen(true);
    }
  }, [i]);

  //页面横屏 直接在最外层的div调用该函数即可 changeOrientation($(".heng"));
  function changeOrientation($print) {
    console.log("旋转");
    var width = document.documentElement.clientWidth;
    var height = document.documentElement.clientHeight;
    if (width < height) {
      // 竖屏
      $print.width(height);
      $print.height(width);
      $print.css("top", (height - width) / 2);
      $print.css("left", 0 - (height - width) / 2);
      $print.css("transform", "rotate(90deg)");
      $print.css("transform-origin", "50% 50%");
    }
    var evt = "onorientationchange" in window ? "orientationchange" : "resize";

    window.addEventListener(
      evt,
      function () {
        //   console.log(evt);
        setTimeout(function () {
          var width = document.documentElement.clientWidth;
          var height = document.documentElement.clientHeight;
          if (width > height) {
            // 横屏
            $print.width(width);
            $print.height(height);
            $print.css("top", 0);
            $print.css("left", 0);
            $print.css("transform", "none");
            $print.css("transform-origin", "50% 50%");
          } else {
            // 竖屏
            $print.width(height);
            $print.height(width);
            $print.css("top", (height - width) / 2);
            $print.css("left", 0 - (height - width) / 2);
            $print.css("transform", "rotate(90deg)");
            $print.css("transform-origin", "50% 50%");
          }
        }, 300);
      },
      false
    );
  }
  //计算字体大小,返回数值大小
  function calculateFontSize() {
    var baseSize =
        window.location.href.includes("DigitalResourceLibrary") ||
        window.location.href.includes("GQKP")
          ? 10
          : 6, // 基数
      baseWidth = 375, //量取值大小
      winw =
        document.documentElement.clientWidth <
        document.documentElement.clientHeight
          ? document.documentElement.clientWidth
          : document.documentElement.clientHeight,
      fontSize = ((winw / baseWidth) * baseSize).toFixed(2);
    document.getElementsByTagName("html")[0].style.fontSize = fontSize + "px";
    return fontSize;
  }
  useEffect(() => {
    if (isPhone) {
      if (
        !(
          window.location.href.includes("DigitalResourceLibrary") ||
          window.location.href.includes("GQKP")
        )
      ) {
        changeOrientation($("body"));
      }

      calculateFontSize();
    }
  }, [isPhone]);
  return (
    <div
      className={
        isBigScreen ? "bigscreen-page" : isPhone ? "mobile-page" : "pc-page"
      }
    >
      <NavContext.Provider value={{ navData, navData2, setNavData }}>
        <Router>
          <Routes>
            {/* 路由配置 */}
            {pcRoutes.map((route) => {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                />
              );
            })}
            {/* 默认路由，处理未匹配的路径 */}
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </Router>
      </NavContext.Provider>
    </div>
  );
}

export default App;

export function useNav() {
  return useContext(NavContext);
}
